import React, { useState } from "react";
import { Download } from "lucide-react";
import { exportPDFC } from "../../sharedfiles/pdfExport";
import downloadCsv from "download-csv";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../ui/select";
import { Button } from "../../ui/button";

const PDF_CELL_MAX_LENGTH = 200;

function downloadCsvFile(rawHeaders, rawData, fileName) {
  let headers = {};
  rawHeaders.forEach((key) => { headers = { ...headers, [key]: key }; });
  const bodyData = rawData.map((item) => {
    let obj = {};
    for (let key in item) { obj = { ...obj, [rawHeaders[key]]: item[key] }; }
    return obj;
  });
  downloadCsv(bodyData, headers, fileName);
}

const DownloadWidget = ({
  tableData = [],
  fileName = "download",
  pdfTitle = "Report",
  pdfSize = "A2",
}) => {
  const [documentType, setDocumentType] = useState("PDF");

  const headers = tableData.length > 0 ? tableData[0] : [];
  const dataRows = tableData.length > 2
    ? tableData.slice(2).filter(row => Array.isArray(row) && row.length > 0)
    : [];

  if (dataRows.length === 0) return null;

  const truncateForPdf = (rows) =>
    rows.map((row) =>
      row.map((cell) => {
        if (typeof cell === "string" && cell.length > PDF_CELL_MAX_LENGTH) {
          return cell.substring(0, PDF_CELL_MAX_LENGTH) + "...";
        }
        return cell;
      })
    );

  const handleDownload = () => {
    if (documentType === "PDF") {
      exportPDFC(pdfTitle, [headers], truncateForPdf(dataRows), {}, null, pdfSize);
    } else {
      downloadCsvFile(headers, dataRows, `${fileName}.csv`);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Select value={documentType} onValueChange={setDocumentType}>
        <SelectTrigger className="w-[80px] h-8 text-sm">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="PDF">PDF</SelectItem>
          <SelectItem value="CSV">CSV</SelectItem>
        </SelectContent>
      </Select>
      <Button size="sm" onClick={handleDownload} type="button" className="h-8 w-8 p-0">
        <Download className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default DownloadWidget;
